/**
 * Высота кнопки с раскрытыми товарами
 */
export const BUTTON_HEIGHT_PRODUCT_EXPANDED = 56;

/**
 * Отступ, при вычитании которого из 100% можно
 * получить доступную ширину развернутой кнопки
 */
export const BUTTON_WIDTH_EXPANDED_INDENTION = 32;

/**
 * Величина, на которую надо сдвигать каждое медие в кнопке товара
 */
export const MEDIA_ITEM_OFFSET = 20;

/**
 * Отступ, при вычитании которого из 100% можно
 * получить доступную ширину текста в кнопке товара
 */
export const PRODUCT_TEXT_CONTAINER_WIDTH_INTENTION = 50;

/**
 * Отступ, при вычитании которого из 100% можно
 * получить доступную ширину контента в кнопке товара
 */
export const PRODUCT_CONTENT_WIDTH_INTENTION = 30;

/**
 * Отступ, при вычитании которого из 100% можно
 * получить доступную ширину контейнера товара
 */
export const PRODUCT_CONTAINER_WIDTH_INTENTION = 16;
